(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["course-cart-handoff"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-course-handoff]');
    if (!root) return;
    const status = root.querySelector('[data-handoff-status]');
    const retry = root.querySelector('[data-handoff-retry]');
    const back = root.querySelector('[data-handoff-back]');
    const languageForm = root.querySelector('#CourseHandoffLanguage');
    const apiRoot = root.dataset.apiRoot.replace(/\/?$/, '/');
    const shopLocales = { en: 'en', de: 'de', fr: 'fr', es: 'es', it: 'it', pt: 'pt-BR', ru: 'ru', ja: 'ja', ko: 'ko', 'zh-CN': 'zh-CN' };
    const pendingKey = 'hammerflower-pending-handoff';
    const completedKey = 'hammerflower-completed-handoffs';
    const ttl = 30 * 60 * 1000;
    const lineProperty = '_course_line_item_id';
    const params = new URLSearchParams(location.hash.slice(1));
    let token = params.get('course-handoff');
    let locale = params.get('locale') || (root.dataset.currentLocale === 'pt-BR' ? 'pt' : root.dataset.currentLocale);
    function storage(name) {
      try { return name === 'local' ? localStorage : sessionStorage; } catch { return null; }
    }
    const sessionStore = storage('session');
    const localStore = storage('local');
    let busy = false;
    let completedInMemory = false;
    let stage = 'shop_token';
    let responseStatus = 0;
    let fallingBack = false;
    const watchdog = setTimeout(() => fallback(), 45000);

    function read(store, key, fallback) {
      try { return JSON.parse(store.getItem(key)) || fallback; } catch { return fallback; }
    }
    function write(store, key, value) {
      try { store.setItem(key, JSON.stringify(value)); } catch { /* Storage is optional. */ }
    }
    if (token && /^[A-Za-z0-9_-]{43}$/.test(token)) {
      write(sessionStore, pendingKey, { token, locale, createdAt: Date.now() });
      history.replaceState(null, '', location.pathname + location.search);
    } else {
      const saved = read(sessionStore, pendingKey, {});
      token = Date.now() - saved.createdAt < ttl ? saved.token : null;
      locale = saved.locale || locale;
    }

    if (typeof locale === 'string' && /^[a-z]{2}(?:-[A-Z]{2})?$/.test(locale)) {
      back.href = `https://learn.hammerflower.art/${locale}/buy`;
    }

    function fallback() {
      if (fallingBack) return;
      fallingBack = true;
      clearTimeout(watchdog);
      try {
        void fetch('https://learn.hammerflower.art/api/course-cart/report', {
          method: 'POST', credentials: 'omit', keepalive: true,
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({ stage, locale: shopLocales[locale] ? locale : 'en', status: responseStatus }),
        }).catch(() => {});
      } catch { /* Reporting cannot prevent the redirect. */ }
      location.replace(apiRoot + 'products/flower-hammering-for-beginners');
    }
    async function json(url, options = {}) {
      if (fallingBack) throw new Error('Handoff stopped');
      responseStatus = 0;
      const response = await fetch(url, { ...options, cache: 'no-store', signal: AbortSignal.timeout(15000) });
      if (fallingBack) throw new Error('Handoff stopped');
      responseStatus = response.status;
      if (!response.ok) {
        const failure = new Error('handoff');
        failure.expired = response.status === 410;
        throw failure;
      }
      return response.json();
    }
    async function prepare() {
      const completed = read(localStore, completedKey, {});
      if (completedInMemory || (completed[token] && Date.now() - completed[token] < ttl)) return;
      stage = 'shop_resolve';
      const selection = await json('https://learn.hammerflower.art/api/course-cart/resolve', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }), credentials: 'omit',
      });
      stage = 'shop_selection';
      if (!selection || !Array.isArray(selection.items) || !selection.items.length || selection.items.length > 20 ||
          typeof selection.locale !== 'string' || !/^[a-z]{2}(?:-[A-Z]{2})?$/.test(selection.locale) ||
          selection.items.some((item) => !Number.isSafeInteger(item.id) || item.quantity !== 1 ||
            typeof item.properties?.[lineProperty] !== 'string' || !item.properties[lineProperty].startsWith('learn-'))) {
        throw new Error('Invalid selection');
      }
      back.href = `https://learn.hammerflower.art/${selection.locale}/buy`;
      locale = selection.locale;
      stage = 'shop_cart';
      const cart = await json(apiRoot + 'cart.js');
      const existing = new Set(cart.items.map((item) => item.properties?.[lineProperty]));
      const missing = selection.items.filter((item) => !existing.has(item.properties[lineProperty]));
      if (missing.length) {
        stage = 'shop_add';
        await json(apiRoot + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: missing.slice().reverse() }),
        });
      }
      stage = 'shop_update';
      const updated = await json(apiRoot + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { course_locale: selection.locale } }),
      });
      stage = 'shop_verify';
      for (const requested of selection.items) {
        const seat = updated.items.find((item) => item.properties?.[lineProperty] === requested.properties[lineProperty]);
        if (!seat || seat.quantity !== 1) throw new Error('Incomplete cart');
      }
      completedInMemory = true;
      const fresh = Object.fromEntries(Object.entries(completed).filter(([, timestamp]) => Date.now() - timestamp < ttl));
      fresh[token] = Date.now();
      write(localStore, completedKey, fresh);
    }
    async function run() {
      if (busy) return;
      if (!token || !/^[A-Za-z0-9_-]{43}$/.test(token)) {
        status.textContent = root.dataset.expired;
        retry.hidden = true;
        fallback();
        return;
      }
      busy = true;
      retry.hidden = true;
      status.textContent = root.dataset.loading;
      try {
        if (navigator.locks) await navigator.locks.request('hammerflower-course-cart', prepare);
        else await prepare();
        if (fallingBack) return;
        stage = 'shop_redirect';
        const available = (root.dataset.availableLocales || '').split(',');
        const requested = shopLocales[locale] || 'en';
        const target = available.find((code) => code.toLowerCase() === requested.toLowerCase()) || 'en';
        if (languageForm && target.toLowerCase() !== (root.dataset.currentLocale || 'en').toLowerCase()) {
          languageForm.querySelector('[name="language_code"]').value = target;
          languageForm.querySelector('[name="return_to"]').value = root.dataset.cartUrl;
          languageForm.submit();
        } else {
          clearTimeout(watchdog);
          location.replace(root.dataset.cartUrl);
        }
      } catch (error) {
        status.textContent = error.expired ? root.dataset.expired : root.dataset.error;
        retry.hidden = true;
        fallback();
      } finally { busy = false; }
    }
    retry.addEventListener('click', run);
    run();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
